import { Box, Heading } from '@chakra-ui/react';

import { GlyphTitleMarkdown } from '../models/shared-models';

import { EnterpriseResourceGlyphCard } from './enterprise-resource-glyph-card';

export function EnterpriseResourceGlyphCardSection({
  title,
  cardList,
}: {
  title: string;
  cardList: GlyphTitleMarkdown[];
}) {
  return (
    <Box>
      <Heading as='h2' margin='auto' maxWidth='736px' size='marketing-4xl' textAlign='center'>
        {title}
      </Heading>

      <Box display='flex' flexWrap={{ base: 'wrap', lg: 'nowrap' }} gap='32px' justifyContent='center' marginTop='40px'>
        {cardList.map(({ glyphName, title, markdownContent }) => (
          <EnterpriseResourceGlyphCard
            key={title}
            flexBasis={{ base: '100%', lg: '33%' }}
            glyphName={glyphName}
            markdownContent={markdownContent}
            maxWidth={{ base: 'unset', md: '352px', lg: 'unset' }}
            title={title}
          />
        ))}
      </Box>
    </Box>
  );
}
